export const CountryDateFormatter = {
    '1': 'MM/dd/yyyy',  //us
    '2': 'dd/MM/yyyy',   //uk
    '3': 'yyyy/MM/dd',  //canada
    '4': 'dd/MM/yyyy',  //fra
    '5': 'dd/MM/yyyy',  //mexico
    '6': 'yyyy/MM/dd',  //japan
    '7': 'dd/MM/yyyy',  //australia
    '8': 'dd/MM/yyyy', //germany
    '9': 'dd/MM/yyyy', //spain
    '10': 'yyyy/MM/dd', //south korea
    '11': 'dd/MM/yyyy', //italy
}